import { Image } from '@spritz-finance/ui'
import { useMemo } from 'react'
import styled from 'styled-components'
import { Me } from '../context/useCurrentUser'
import { FullUserFragment } from '../graphql/generated/graphql'

const Avatar = styled.img<{ $size?: number }>`
    border-radius: 50%;
    ${({ $size = 50 }) => `
        height: ${$size}px;
        width: ${$size}px;
    `}
`

const useDefaultSprite = (me: Me) =>
    useMemo(() => {
        if (!me.firstName) return Image.Sprite1
        return me.firstName.length % 2 === 0 ? Image.Sprite1 : Image.Sprite2
    }, [me])

export const UserAvatar = ({ user, size = 60 }: { user: FullUserFragment; size?: number }) => {
    const Sprite = useDefaultSprite(user)
    return user.picture ? (
        <Avatar src={user.picture} $size={size} width={size} height={size} />
    ) : (
        <Sprite width={size} height="auto" />
    )
}
